import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IMerchantDeleteressDeleteRequest {
    id: number;
}

async function merchantCurrentBalanceMovementDelete(
    data: IMerchantDeleteressDeleteRequest
): Promise<any> {
    try {
        return (await axiosInstance.delete("/MerchantCurrentBalanceMovement/Delete?id=" + data.id))
            .data;
    } catch (ex) {
        throw ((ex as AxiosError).response?.data as any).error;
    }
}

export function useMerchantCurrentBalanceMovementDelete() {
    return useMutation<any, Error, IMerchantDeleteressDeleteRequest>(
        (variables) => merchantCurrentBalanceMovementDelete(variables)
    );
}
